/**
 * Case insensitive header getter
 */
export function getHeader(r: Request | Response, name: string) {
  return r.headers.get(name) || r.headers.get(name.toLowerCase())
}
